// extracted by mini-css-extract-plugin
export default {"container":"Menu_container__6vzIm","divider":"Menu_divider__54oBf","option":"Menu_option__OVJZJ","no_bg":"Menu_no_bg__Ptqbk"};